/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'commission': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#848484" fill-rule="nonzero"><path pid="0" d="M13.043 11.061a1.981 1.981 0 1 0 0 3.963 1.981 1.981 0 0 0 0-3.963zm0 2.852a.87.87 0 1 1 0-1.74.87.87 0 0 1 0 1.74zM6.957 8.939a1.981 1.981 0 1 0 0-3.963 1.981 1.981 0 0 0 0 3.963zm0-2.852a.87.87 0 1 1 0 1.74.87.87 0 0 1 0-1.74zM14.075 5.14L5.14 14.074a.555.555 0 1 0 .786.786l8.936-8.936a.555.555 0 1 0-.786-.786z"/><path pid="1" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10C19.994 4.48 15.52.006 10 0zm0 18.889A8.889 8.889 0 1 1 18.889 10 8.899 8.899 0 0 1 10 18.889z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/commission.js